import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'

import { Button, FormControl, Grid,
         Input, InputLabel, Paper, Typography
} from '@mui/material';

import AccountCreateMutation from './AccountCreateMutation';
import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    sectionTitleFirst: {
      marginBottom: 3
    },
    sectionTitle: {
      marginTop: 15,
      marginBottom: 3
    },
    button: {
      marginTop: 15,
      marginBottom: 15,
      marginRight: 8
    }
  });
  
class ResellerCreate extends Component {
    state = {
        showSpinner: false,
        parentId: abEnvironment.getUserAttribute('a_id'),
        accountType: 3,
        accountNum: '',
        accountName: '',
        description: 'New account',
        contactLastName: '',
        contactFirstName: '',
        contactEmail: '',
        contactPhone: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        postalCode: ''
    }

    goBack() {
      this.props.history.goBack();
    }
    
     goTo(route) {
        this.props.history.replace(`/${route}`);
    }
    
    showSpinner() {
      return this.state.showSpinner;
    }
    
    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  
    
    render() {
        const { isAuthenticated, isAuthenticatedAppBind, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedAppBind() || needAssent()) {
          let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let regionLabel = "Region";

          return (
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <Grid item xs={12}>
                <PageTitle title="Add a new reseller" showBackButton={true} name="Accounts" noMargin={true} history={this.props.history}/>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Grid container spacing={2} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <Typography variant="h6" className={classes.sectionTitleFirst}>
                        Account
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl required={true}>
                        <InputLabel htmlFor="customer-name">Reseller account name</InputLabel>
                        <Input id="customer-name" value={this.state.accountName}
                          onChange={(e) => this.setState({ accountName: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl >
                        <InputLabel htmlFor="name-helper">Account number</InputLabel>
                        <Input id="account-num" value={this.state.accountNum} 
                              onChange={(e) => this.setState({ accountNum: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <InputLabel htmlFor="name-helper">Description</InputLabel>
                        <Input id="description" value={this.state.description} 
                              onChange={(e) => this.setState({ description: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" className={classes.sectionTitle}>
                        Primary contact
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl >
                        <InputLabel htmlFor="first-name">First name</InputLabel>
                        <Input  data-recording-ignore="mask" id="first-name" value={this.state.contactFirstName}
                          onChange={(e) => this.setState({ contactFirstName: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="last-name">Last name</InputLabel>
                        <Input  data-recording-ignore="mask" id="last-name" value={this.state.contactLastName}
                          onChange={(e) => this.setState({ contactLastName: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="email">Email</InputLabel>
                        <Input  data-recording-ignore="mask" id="email" value={this.state.contactEmail}
                              onChange={(e) => this.setState({ contactEmail: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="phone">Phone</InputLabel>
                        <Input  data-recording-ignore="mask" id="phone" value={this.state.contactPhone}
                              onChange={(e) => this.setState({ contactPhone: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" className={classes.sectionTitle}>
                        Mailing address
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Address
                        address={address}
                        regionLabel={regionLabel}
                        setCountryCodeState={this.setCountry}
                        setRegionCodeState={this.setRegion}
                        setCityState={this.setCity}
                        setPostalCodeState={this.setPostalCode}
                        setAddress1State={this.setAddress1}
                        setAddress2State={this.setAddress2}
                      />
                    </Grid>
                    {/* 
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="address1">Address 1</InputLabel>
                        <Input id="address1" value={this.state.address1}
                              onChange={(e) => this.setState({ address1: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="address2">Address 2</InputLabel>
                        <Input id="address2" value={this.state.address2}
                              onChange={(e) => this.setState({ address2: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FormControl>
                        <InputLabel htmlFor="city">City</InputLabel>
                        <Input id="city" value={this.state.city}
                              onChange={(e) => this.setState({ city: e.target.value })} />
                      </FormControl>
                      </Grid>
                    <Grid item xs={6} sm={3}>
                      <FormControl>
                        <InputLabel htmlFor="state">State</InputLabel>
                        <Input id="state" value={this.state.state}
                              onChange={(e) => this.setState({ state: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FormControl>
                        <InputLabel htmlFor="country">Country</InputLabel>
                        <Input id="country" value={this.state.country}
                              onChange={(e) => this.setState({ country: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <FormControl>
                        <InputLabel htmlFor="postal-code">Postal Code</InputLabel>
                        <Input id="postal-code" value={this.state.postalCode}
                              onChange={(e) => this.setState({ postalCode: e.target.value })} />
                      </FormControl>
                    </Grid>
                    */}
                    <Grid item xs={12}>
                      { !this.showSpinner() && this.state.accountName &&
                      <Button variant="contained" color="primary" className={classes.button} onClick={() => {this._createReseller()}}>
                        Save
                      </Button>
                      }
                      { !this.showSpinner() && ! this.state.accountName &&
                      <Button variant="contained" color="primary" className={classes.button}>
                        Save
                      </Button>
                      }
                      {this.showSpinner() &&
                      <Button color="primary" variant="contained" >
                        <SavingSpinner/></Button>
                      }
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    _createReseller = () => {
      this.setState({ showSpinner: true });
      const { parentId, accountType, accountNum, accountName, description,
              contactLastName, contactFirstName, contactEmail, contactPhone,
              address1, address2, city, state, country, postalCode } = this.state;
      AccountCreateMutation.commit(parentId, accountType, accountNum, accountName, description, 
                                   contactLastName, contactFirstName, contactEmail, contactPhone,
                                   address1, address2, city, state, country, postalCode)
      .then(response => {
        let theId = response.createAccountT.accountT.accountId;
        // console.log('Reseller create mutation complete');
        this.setState({ showSpinner: false });
        let replaceUrl = 'reseller?accountId=' + theId;
        this.goTo(replaceUrl);
      })
      .catch(error => {
        // console.log('Reseller create mutation error: ' + error);
        this.setState({ showSpinner: false });
        this.goBack();
      });
    }
}

ResellerCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(ResellerCreate);